import {
    ConversationEntryType,
    Tmv2ProblemMode,
    type ConversationEntry,
} from "@khan/guide-types";

export const tutorMeConversationHasInvalidProblem = (
    conversationEntries: readonly ConversationEntry[],
) => {
    if (!conversationEntries || conversationEntries.length === 0) {
        return false;
    }

    let detectedInvalidProblem = false;

    for (let i = 0; i < conversationEntries.length; i++) {
        const entry = conversationEntries[i];
        if (entry.type !== ConversationEntryType.Tmv2Problem) {
            continue;
        }
        if (entry.mode === Tmv2ProblemMode.Tmv2ProblemModeInvalidProblem) {
            detectedInvalidProblem = true;
        }
        if (
            entry.mode === Tmv2ProblemMode.Tmv2ProblemModeTutoringStem &&
            detectedInvalidProblem
        ) {
            return true;
        }
    }
    return false;
};
